<script>
import { mapState, mapMutations } from "vuex";
import Summary from "@/components/ContractModals/Components/BaseParts/Summary";

export default {
  extends: Summary,
  computed: {
    ...mapState("QuotationContractModal", ["prices"])
  },
  methods: {
    ...mapMutations("QuotationContractModal", ["setSubtotal", "setVat", "setTotal"])
  }
};
</script>
